import {assestsDomains} from '../helpers/Constants'

const [imgContentfulDomain, videoContentfulDomain] = assestsDomains;
export const optimizeImage = (imageUrl, imageFormatValue, imageQualityValue) => {
    let imageFormat = imageFormatValue ? imageFormatValue : 'webp';
    let imageQuality = imageQualityValue ? imageQualityValue : 75;
    if((imageUrl !== undefined) && (imageUrl !== null) && imageUrl.includes(imgContentfulDomain) && (imageUrl.includes('fm=webp') == false) && (imageUrl.includes('.svg') == false)) {
        if(imageUrl?.includes('https')) {
            if(imageUrl?.includes('?') ) {
                imageUrl = imageUrl + `&fm=${imageFormat}` + `&q=${imageQuality}`;
            }
            else {
                imageUrl = imageUrl + `?fm=${imageFormat}` + `&q=${imageQuality}`;
            }
        }
        else {
            imageUrl = 'https:' + imageUrl
            if(imageUrl?.includes('?')) {
                imageUrl = imageUrl + `&fm=${imageFormat}` + `&q=${imageQuality}`;
            }
            else {
                imageUrl = imageUrl + `?fm=${imageFormat}` + `&q=${imageQuality}`;
            }
        }
    }
    return imageUrl;
}

export const optimizeVideo = (videoUrl, videoFormatValue, videoQualityValue) => {
    let videoFormat = videoFormatValue ? videoFormatValue : 'webm';
    let videoQuality = videoQualityValue ? videoQualityValue : 'auto';
   if(videoUrl &&
      videoUrl.includes(videoContentfulDomain) &&
      !videoUrl.includes('fm=webm')) {
    if (!videoUrl?.includes('https')) {
      videoUrl = 'https:' + videoUrl;
    }
    
    const separator = videoUrl?.includes('?') ? '&' : '?';
    videoUrl = videoUrl + `${separator}fm=${videoFormat}&q=${videoQuality}`;
  }
    return videoUrl;
}